import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=15c5c5cc&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"
import style1 from "./welcome.vue?vue&type=style&index=1&id=15c5c5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c5c5cc",
  null
  
)

export default component.exports